import React from 'react';
import {MasterLayout} from 'layout';
import {BoSungThongTin} from "modules/bo-sung-thong-tin";

class BoSungThongTinPage extends React.Component {

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <BoSungThongTin params={this.props.params}/>
      </MasterLayout>
    );
  }
}

export default BoSungThongTinPage;


// WEBPACK FOOTER //
// ./src/components/pages/bo-sung-thong-tin/BoSungThongTinPage.jsx